// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { triangleTwoLinesHorizontal } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-triangle-two-lines-horizontal': IconTriangleTwoLinesHorizontal;
    }
}

/**
 * The icon component for the 'triangleTwoLinesHorizontal' icon
 */
export class IconTriangleTwoLinesHorizontal extends Icon {
    public constructor() {
        super(triangleTwoLinesHorizontal);
    }
}

registerIcon('icon-triangle-two-lines-horizontal', IconTriangleTwoLinesHorizontal);
export const iconTriangleTwoLinesHorizontalTag = 'nimble-icon-triangle-two-lines-horizontal';
